import React from "react";
import { MdOutlineClose } from "react-icons/md";

function ModelPreviewDefault({
  children,
  isOpen,
  closeModel,
  previewHeading,
  childrenClassName = "",
  modalClassName = "lg:w-[600px]",
}) {
  if (!isOpen) {
    return null;
  }

  return (
    <>
      <div className="fixed inset-0 flex items-center justify-center z-40 bg-black bg-opacity-50">
        <div
          className={`relative bg-white border-[#D2D2D2] text-black rounded-[6px]  w-11/12 ${modalClassName}`}
        >
          <div className="flex justify-between  items-start px-6 pt-4">
            <div>
              <h1 className="text-xl font-bold text-black">{previewHeading}</h1>
            </div>
            {closeModel && (
              <div
                className="w-8 h-8 cursor-pointer rounded-full bg-[#ECECEC] hover:bg-[#ECECEC]/80 flex justify-center items-center"
                onClick={closeModel}
              >
                <MdOutlineClose title="Close" />
              </div>
            )}
          </div>
          <div className={childrenClassName}>{children}</div>
        </div>
      </div>
    </>
  );
}

export default ModelPreviewDefault;
